import Papa from "papaparse";
import { ImportFileType } from "../../const/file-type";
import { Delimiters } from "../../const/delimiters";

const ROWS_TO_PREVIEW = 10;

function isRowValid(row) {
  return row && row.filter((field) => field !== "").length > 0;
}

// Should be customized based on real-life examples
function skipFirstLine(rows) {
  return (
    rows.length > 1 &&
    rows[0].every((field) => typeof field === "string") &&
    rows[0].map((field) => field.toLowerCase()).some((field) => /mail/.test(field)) &&
    rows[1].some((field) => field.includes("@"))
  );
}

function isExcelSpreadsheet(file) {
  return (
    file.name.endsWith(".xlsx") ||
    file.name.endsWith(".xls") ||
    file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  );
}

function parseExcelSpreadsheet({ file, delimiter }, onComplete) {
  if (!window.Worker) {
    window.showToast("Cannot process xlsx file using this browser", "error");

    onComplete({
      type: ImportFileType.Excel,
      previewRows: [],
      skipFirstLine: false,
      noOfRows: 0,
      delimiter: Delimiters.Comma,
    });
  }

  // xlsx.worker.js is a bundled xls-worker.js file with SheetJS library inside - it has to be served locally
  // because Web Workers do not support cross-origin requests.
  // It could be also handled differently (synchronously) if excel file is smaller than x MB.
  const worker = new Worker("/assets/js/import-v2/xlsx.worker.js");
  worker.postMessage(file);

  worker.onmessage = function (e) {
    const rows = e.data;

    onComplete({
      type: ImportFileType.Excel,
      previewRows: rows,
      skipFirstLine: skipFirstLine(rows),
      noOfRows: rows.length,
      delimiter: Delimiters.Comma,
    });
  };
}

function parseCSVFile({ file, delimiter }, onComplete) {
  Papa.parse(file, {
    delimiter,
    skipEmptyLines: true,
    complete: function (results) {
      const previewRows = [];

      for (let i = 0; i < ROWS_TO_PREVIEW; i++) {
        const row = results.data[i];
        if (isRowValid(row)) {
          previewRows.push(row);
        }
      }

      onComplete({
        type: ImportFileType.CSV,
        previewRows,
        skipFirstLine: skipFirstLine(results.data),
        noOfRows: results.data.length,
        delimiter: results.meta.delimiter,
      });
    },
  });
}

export function parseFile({ file, delimiter }, onComplete) {
  if (isExcelSpreadsheet(file)) {
    parseExcelSpreadsheet({ file, delimiter }, onComplete);
  } else {
    parseCSVFile({ file, delimiter }, onComplete);
  }
}
